<template>
    <div class="container container-login">
        <div class="d-flex justify-content-center h-100 main-login">
            <div class="user_card" style="height: 90%">
                <div v-if="showWaitPopup" class="wait-overlay">
                    <div class="wait-popup">
                        <div class="wait-title">
                            <div class="wait-title">
                                Vui lòng đợi
                                <span style="color: red; font-weight: 700;">{{ waitSeconds }}</span> giây
                                để hệ thống hoàn tất đăng ký và tải bài thi của bạn.
                            </div>
                        </div>

                        <div class="wait-progress">
                            <div class="wait-progress-fill" :style="{ width: progress + '%' }"></div>
                        </div>
                    </div>
                </div>
                <div class="login-detail">
                    <span>
                        <a href="" onclick="window.open('https://www.masterkorean.vn/login?register=exam', 'okmedia', 'width=999,height=999,toolbar=no,location=no,menubar=no,copyhistory=no,status=no,directories=no,scrollbars=yes,resizable=no'); return false;" style="color: #2e79dc;font-size: 15px;">Đăng ký</a>
                    </span>
                    <div class="d-flex justify-content-center image-forgot">
                        <div class="image-detail">
                            <div class="logo-login">
                                <img src="../Rectangle.png" class="brand_logo" alt="Logo"/>
                            </div>
                        </div>
                    </div>
                    <div>
                        <h3 class="style-login">{{ $t("commons.button.login") }}</h3>
                    </div>

                    <div class="d-flex justify-content-center form_container">
                        <ValidationObserver v-slot="{ handleSubmit }" class="form-login"
                                            style="background-color:white !important;">
                            <form @submit.prevent="handleSubmit(loginUser)" class="login-details"
                                  style="background-color:white !important;" novalidate>
                                <ValidationProvider
                                        :name="$t('user_problem.label.username')"
                                        rules="min:5|required"
                                        v-slot="{ errors }"
                                        style="background-color:white !important;"
                                >
                                    <div>
                                        <p class="title-inpput required">{{ $t('user_problem.label.username') }}</p>
                                    </div>

                                    <div class="style-form">
                                        <input
                                                type="text"
                                                :maxlength="256"
                                                :minlength="6"
                                                required
                                                class="form-control input_user custom-input  input-login"
                                                :placeholder="$t('user_problem.label.username')"
                                                v-model.trim="user_name"
                                        >
                                    </div>
                                    <span class="text-danger"> {{ errors[0] ? $t('user_problem.label.user_minimum') : null }} </span>
                                </ValidationProvider>
                                <ValidationProvider
                                        :name="$t('commons.label.password')"
                                        rules="required|min:6"
                                        v-slot="{ errors }"
                                >
                                    <div class="form-input">
                                        <p class="title-inpput required">{{ $t('commons.label.password') }}</p>
                                        <div class="style-form">
                                            <input
                                                    :type="typePasswordChange"
                                                    :maxlength="256"
                                                    class="form-control input_user custom-input input-login"
                                                    :placeholder="$t('commons.label.password')"
                                                    v-model="password"
                                                    style="width: 100%"
                                            >
                                            <div @click="changeConfirmPassword()" class="hide-password">
                                                <ion-icon v-if="eyeHide" name="eye-outline"
                                                          class="icon-eye-login"></ion-icon>
                                                <ion-icon v-if="eyeShow" name="eye-off-outline"
                                                          class="icon-eye-login"></ion-icon>
                                            </div>
                                        </div>
                                        <span class="text-danger"> {{ errors[0] ? $t('user_problem.label.password_minimum') : null }} </span>
                                    </div>

                                </ValidationProvider>

                                <div class="login-style">
                                    <div class="d-flex justify-content-center login_container">
                                        <button type="submit" name="button" class="btn login_btn primary">
                                            <div>{{ $t("commons.button.login") }}</div>
                                        </button>
                                        <br>
                                    </div>
                                    <div class="login-description">
                                      <div class="d-flex justify-content-center links mt-3 text-center " style="font-style: normal;">
                                          <a href="https://job.masterkorean.vn/local/job/auth/oauth2login.php?providername=facebook&fbtypemkv2=2" style="color: #2e79dc;font-size: 15px; margin-right: 10px">
                                              {{ $t("commons.label.login_by_facebook") }}
                                          </a> |
                                          <a href="https://job.masterkorean.vn/local/job/auth/oauth2login.php?providername=google&fbtypemkv2=2" style="color: #2e79dc;font-size: 15px;margin-left: 10px">
                                              {{ $t("commons.label.login_by_google") }}
                                          </a>
                                      </div>
                                        <div class="d-flex justify-content-center links mt-3 text-center ">
                                            <span style="color: #9b9b9b; font-size: 12px;">({{ $t("commons.label.login_same_as_mk") }})</span>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </ValidationObserver>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions}                             from "vuex";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import Cookies                                  from "js-cookie";
import router from "@/router";

export default {
  name: "LoginStudent",
  components: {
    ValidationProvider,
    ValidationObserver
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.from = from;
    });
  },
    created() {
        /*---------------------------------------*/
        this.batchCheck();
        /*---------------------------------------*/
      window.history.replaceState(null, null, window.location.pathname);
      Cookies.remove("rsr-user-token");
      Cookies.remove("studentName");
      Cookies.remove("student-permissions");
    },
    data() {
        return {
            typePasswordChange: "password",
            eyeHide: false,
            eyeShow: true,
            user_name: "",
            password: "",
            from: null,

            str_key: "",
            user_id: 0,
            exam_id: 0,
            exam_name: "",

            showWaitPopup: false,     // hiện popup hay không
            waitSeconds: 0,           // số giây còn lại để đợi
            waitSecondsInitial: 0,    // tổng số giây ban đầu (dùng tính %)
            progress: 100,            // % thanh progress bar
            _waitInterval: null,
            temp_waitSeconds: 0,
        };
    },
    methods: {
      ...mapActions("auth", ["loginStudent", "autoLoginStudentB2B"]),
      changeConfirmPassword() {
        if (this.typePasswordChange === "text") {
          this.typePasswordChange = "password";
          this.eyeHide = false;
          this.eyeShow = true;
        } else if (this.typePasswordChange === "password") {
          this.typePasswordChange = "text";
          this.eyeHide = true;
          this.eyeShow = false;
        }
        },
      async loginUser() {
       if(Cookies.get("redirect_from_mk_b2b")){
           Cookies.remove("redirect_from_mk_b2b");
       }
        var str = this.user_name.trim();

        const params = {
          username: str,
          password: this.password
        };
        this.$root.$loading.start();

        await this.loginStudent(params);
          // if(this.$store.state.auth.loginRes == "200"){
          //     this.$root.toast(
          //         this.$t("commons.label.create_success_title"),
          //         "danger",
          //         this.$t(`msg["C_UC1_01"]`)
          //     );
          // }
        this.$root.$loading.finish();
          if (this.$store.state.auth.loginRes == "4000") {
              this.$root.toast(
                  this.$t("commons.message.send_fail"),
                  "danger",
                  this.$t("commons.message.wrong_password_username")
              );
          } else if (this.$store.state.auth.loginRes.message === "E_UC1_49") {
              this.$root.toast(
                  this.$t(`msg["E_UC1_49"]`),
                  {
                      title: this.$t("difficulty.notice"),
                      autoHideDelay: 5000,
                      variant: "danger"
                  }
              );
          } else if (this.$store.state.auth.loginRes.status === 200) {
              if (this.from.name === 'Signup' || this.from.name === 'ResetPassword' || this.from.name === 'Forgot') {
                  this.$router.push({name: "Home"});
              } else {
                  this.$router.push({name: "TeacherList"});
              }
          } else {
              this.$root.toast(
                  this.$t("commons.label.login_error"),
                  "danger",
                  this.$t("commons.message.wrong_password_username")
              );
          }
      },
        auto_login() {
            this.$root.$loading.start();
            const search = window.location.search.substring(1).split("&");
            if(search && search.length > 0) {
                let params = {};
                if(search[0] && search[1] && search[1] == 'MKLiveRedirectToExam'){
                    let arr_userId = search[0].split("1285s8sd920458945dk");
                    params = {
                        userId: arr_userId[0],
                        username: '',
                        auto: 1
                    }
                }else {
                    params = {
                        username: this.decode(search[0]),
                        auto: 1
                    }
                }
                const url = new URLSearchParams(search[1])
                this.$store.dispatch("auth/autoLoginStudentB2B", params).finally(() => {
                    if(search[2]){
                        const search2 = new URLSearchParams(search[2])
                        if (search2.getAll("idExam").length > 0) {
                            if (url.getAll("name").length > 0) {
                                // begin: set flag
                                Cookies.remove("redirect_from_mk_b2b");
                                Cookies.set("redirect_from_mk_b2b", 1);
                                // end flag
                                Cookies.remove("idExam");
                                Cookies.set("idExam", search2.getAll("idExam")[0]);
                                router.push(`/student/exam/my-exam/result?${url.getAll("name")[0]}`)
                            }
                        }
                    }else {
                        if (url.getAll("exam").length > 0) {
                            // begin: set flag
                            Cookies.remove("redirect_from_mk_b2b");
                            Cookies.set("redirect_from_mk_b2b", 1);
                            // end flag
                            Cookies.remove("typeExam");
                            Cookies.set("typeExam", 'try_exam');
                            router.push(`/student/exam/try-exam?${url.getAll("exam")[0]}`)
                        } else this.$router.push({name: "TeacherList"});
                    }
                });
            }
            this.$root.$loading.finish();
        },
        auto_login_ext() {
            this.$root.$loading.start();
            let params = {
                userId: this.user_id,
                username: this.user_name,
                auto: 1
            }
            this.$store.dispatch("auth/autoLoginStudentB2B", params).finally(() => {
                this.$root.$loading.finish();
                if(this.exam_id && this.exam_name){
                    // begin: set flag
                    Cookies.remove("redirect_from_mk_b2b");
                    Cookies.set("redirect_from_mk_b2b", 1);
                    // end flag
                    Cookies.remove("idExam");
                    Cookies.set("idExam", this.exam_id);
                    router.push(`/student/exam/my-exam/result?${this.exam_name}`)
                }else {
                    if (this.exam_id) {
                        // begin: set flag
                        Cookies.remove("redirect_from_mk_b2b");
                        Cookies.set("redirect_from_mk_b2b", 1);
                        // end flag
                        Cookies.remove("typeExam");
                        Cookies.set("typeExam", 'try_exam');
                        router.push(`/student/exam/try-exam?${this.exam_id}`)
                    } else this.$router.push({name: "TeacherList"});
                }
            });
        },
        decode(string){
            return new Buffer(string, "hex").toString("ascii")
        },
        async batchCheck() {
            this.showSubmitPopup = false;

            // LẤY CHUỖI HEX ĐẦU TIÊN
            const raw = window.location.search.slice(1);
            this.str_key = raw.split("&")[0];
            if(this.str_key){
                this.user_name = this.decode(this.str_key);
            }

            // LẤY CÁC THAM SỐ KHÁC
            const params = new URLSearchParams(window.location.search);

            if (params.has('user_id')) {
                this.user_id = Number(params.get('user_id'));
            }

            if (params.has('exam')) {
                this.exam_id = Number(params.get('exam'));
            }

            if (params.has('idExam')) {
                this.exam_id = Number(params.get('idExam'));
            }

            if (params.has('name')) {
                this.exam_name = String(params.get('name'));
            }
            if (params.has('batch_check')) {
                this.temp_waitSeconds = Number(params.get('batch_check'));
            }

            if (this.temp_waitSeconds > 0) {

                this.waitSeconds = this.temp_waitSeconds
                this.waitSecondsInitial = this.temp_waitSeconds;
                this.showWaitPopup = true;
                this.progress = 100;

                if (this._waitInterval) clearInterval(this._waitInterval);

                this._waitInterval = setInterval(() => {
                    this.waitSeconds--;
                    this.progress = (this.waitSeconds / this.waitSecondsInitial) * 100;

                    if (this.waitSeconds <= 0) {
                        clearInterval(this._waitInterval);
                        this._waitInterval = null;

                        this.showWaitPopup = false;
                        this.temp_waitSeconds = 0;
                        this.auto_login_ext();
                    }
                }, 1000);

                return;
            }

            // Nếu xử lý ngay
            if (this.temp_waitSeconds === 0) {
                this.auto_login_ext();
                return;
            }
        },
    }
};
</script>

<style scoped>
/* Nền mờ */
.wait-overlay {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;

    background: rgba(0, 0, 0, 0.5);  /* mờ */
    backdrop-filter: blur(2px);       /* làm mờ nền */
    //background: rgba(0,0,0,0.65); /* tối hơn → không thấy rõ nền */
    //backdrop-filter: blur(10px);   /* làm mờ nền */

    z-index: 9999;

    display: flex;
    justify-content: center;
    align-items: center;
}

/* Khung popup */
.wait-popup {
    background: white;
    padding: 25px 35px;
    border-radius: 12px;
    width: 750px;
    text-align: center;
    box-shadow: 0 8px 20px rgba(0,0,0,0.2);
}

/* Tiêu đề */
.wait-title {
    font-size: 20px;
    /*font-weight: bold;*/
    margin-bottom: 15px;
}

/* Thanh progress */
.wait-progress {
    width: 100%;
    height: 12px;
    background: #f0f0f0;
    border-radius: 8px;
    overflow: hidden;
}

.wait-progress-fill {
    height: 100%;
    background: #3fa9f5;    /* màu xanh chạy */
    transition: width 0.3s linear;
}
p {
    margin-bottom: 0px;
}

.container-login {
    display: flex;
    justify-content: center;
    align-content: center;
    height: 100%;
    background: #E5EAFF !important;
    width: 100%;
}

.main-login {
    width: 100%;
}

.user_card {
    height: 80%;
    width: 51%;
    margin-top: auto;
    margin-bottom: auto;
    background: #FFFFFF;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border-radius: 14px;
}

.brand_logo_container {
    position: absolute;
    height: 170px;
    width: 170px;
    top: -75px;
    border-radius: 50%;
    background: #60a3bc;
    padding: 10px;
    text-align: center;
}

.form_container {
    /* margin-top: 6%; */
    width: 100%;
    height: 36%;
    position: relative;
}

.login_btn {
    width: 100%;
    background: #6674BB;
    border-radius: 8px;
}

.login_btn:hover {
    box-shadow: 0px 8px 26px 1px rgba(0, 0, 0, 0.3);
}

.login_btn.btn.disabled, .btn:disabled {
    background-color: #c4c4c4
}

.login_btn div {
    font-family: Roboto;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 28px;
    text-align: center;
    letter-spacing: -0.015em;
    color: #FFFFFF;
}

.login_btn:focus {
    box-shadow: none !important;
    outline: 0px !important;
}

.login_container {
    border-radius: 8px !important;
    height: 29%;
    margin-top: 13%;
    /* position: absolute;
    top: 10%; */
}

.input-group-text {
    /* background: #ff8816 !important; */
    color: white !important;
    border: 0 !important;
    border-radius: 0.25rem 0 0 0.25rem !important;
}

.input_user,
.input_pass:focus {
    box-shadow: none !important;
    outline: 0px !important;
}

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #c0392b !important;
}

h3 {
    margin-bottom: 0px;
    text-align: center;
}

.style-form {
    flex-direction: column-reverse;
    height: 28%;
    position: relative;
}

/* .style-form::placeholder{
    font-size: 1px;
} */

.hide-password {
    position: absolute;
    top: 26%;
    right: 8%;
    border: none;
    background: none;
    /* background-color: white !important; */
    font-size: 24px;

    /* height: ; */
}

.style-login {
    font-family: Roboto;
    font-style: normal;
    font-weight: 700;
    font-size: 46px;
    line-height: 140%;
    color: #000000;
}

.login-detail {
    height: 90%;
    width: 80%;
    justify-content: center;
    align-items: center;
}

.image-login {
    height: 19%;
}

.title-inpput {
    font-family: Roboto;
    font-style: normal;
    /* font-weight: 700; */
    font-size: 21px;
    line-height: 140%;
    color: #000000;
}

.custom-input {
    height: 100% !important;
}

.input-login {
    height: 100% !important;
    width: 100%;
    background: #FFFFFF !important;
    border: 1px solid #E2E8F0;
    box-sizing: border-box;
    border-radius: 8px;
    /* font-size:18px; */
}

.style-form input::placeholder {
    font-size: 18px;
}

.form-login {
    width: 100% !important;
    height: 100%;
}

.login-details {
    height: 100% !important;
    background-color: black;
}

.login-details .row {
    height: 38.5%;
}

.forgot-password {
    font-family: Roboto !important;
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 18px !important;
    line-height: 140% !important;
    color: #000000 !important;
    margin-top: 2%;
}

.image-forgot {
    height: 28.76%;
    margin-bottom: 2%;
}

.image-detail {
    height: 100%;
    /* width: 100%; */
}

.brand_logo {
    /* margin-top:30%; */
    height: 100%;
    width: 100%;
}

.password-style {
    margin-top: 3%;
}

.form-input {
    position: absolute;
    top: 60%;
    width: 100%;
    height: 94%;
}

.login-style {
    position: absolute;
    top: 90%;
    width: 100%;
    height: 94%;
}

.logo-login {
    height: 100%;
    width: 100%;
}

.icon-eye-login {
    color: rgb(46, 121, 220);
}

.login-description{
    color: rgb(46, 121, 220);
    font-style: italic;
    font-size: 15px;
}

/* RESPONSIVE  */
/* Tablets */
@media only screen and (min-width: 768px ) and (max-width: 992px) {
    .user_card {
        width: 80%;
        height: 85%;
    }

    .login-description{
      font-size: 14px;
    }
}

/* Mobile */
@media only screen and (max-width: 768px) {
    .user_card {
        width: 97%;
    }

    .style-login {
        font-size: 25px;
    }

    .title-inpput {
        font-size: 16px;
    }

    .style-form input::placeholder {
        font-size: 15px;
    }

    .login_btn {
        width: 75%;
        height: 50px;
    }

    .text-danger {
        font-size: 14px;
    }

    .login_btn div {
        font-size: 20px;
    }

    .container-login {
        height: 660px;
    }

    .login-description{
      font-size: 12px;
    }
}

</style>
